<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8.31055 5.33325C6.54388 5.33325 4.94388 5.99325 3.71055 7.06659L2.45055 5.80659C2.03055 5.38659 1.31055 5.67992 1.31055 6.27325V9.99992C1.31055 10.3666 1.61055 10.6666 1.97721 10.6666H5.70388C6.29721 10.6666 6.59721 9.94659 6.17721 9.52659L4.90388 8.25325C5.83055 7.47992 7.01055 6.99992 8.31721 6.99992C10.4239 6.99992 12.2439 8.22659 13.1105 9.99992C13.2905 10.3733 13.7172 10.5599 14.1105 10.4266C14.5839 10.2733 14.8239 9.73325 14.6105 9.27992C13.4639 6.94659 11.0772 5.33325 8.31055 5.33325Z"
      fill="#2A2B2A"
    />
  </svg>
</template>
